<template>
  <div  class="header">
    <div style="position: relative;margin: 0px 50px;">
      <img @click="goto('/')" src="@/assets/img/home/title.png" class="tittleiImg" alt="" width="420px" height="34px"/>
      <ul class="list">
        <li style="width: 90px;" :class="this.$route.name==='Information' || this.$route.name==='InformationDetail' ? 'bgColor':''" @click="goto('/information')">
          资讯
        </li>
        <li style="position: relative;width: 90px;" class="el-dropdown-link">
          <span style="font-size:16px;font-weight: 400;color: #333333;">
            工具<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <ul class="downMenu">
            <li @click="goto('/article/Beginner')">产品原型设计工具</li>
            <li @click="gotoProfessional('/article/Professional')">车载应用开发工具</li>
            <li @click="goto(sdkConfig.link)">{{sdkConfig.title}}</li>
          </ul>
        </li>
        <li style="width: 90px;"  :class="this.$route.name==='DevelopDocument' ? 'bgColor':''" @click="goto('/document')">文档</li>
        <li style="width: 90px;"  :class="this.$route.name==='school' || this.$route.name==='schoolDetail' ? 'bgColor':''" @click="goto('/school')">学堂</li>
        <li style="width: 90px;"  :class="this.$route.name.indexOf('forum') !== -1 ? 'bgColor':''" @click="goto('/forum')">论坛</li>
      </ul>
      <div class="to_login" v-if="userInfo === null">
        <span @click="goto('/login')" style="font-size: 12px;display: block;line-height: 36px;">登录 / 注册</span>
      </div>
      <div class="to_loginName" v-else>
        <div style="font-size: 16px;letter-spacing: 1px;display: flex;">
          <img style="width: 30px;height: 30px;border-radius: 50%;margin-right:10px;" @click="goto('/article/account')" :src="userInfo.headPortrait !== null ? userInfo.headPortrait : require( '../../assets/img/pages/tou.png')"/>
          <el-dropdown style="display: flex;align-items: center" placement="top-end">
            <div class="dropdown-link" style="display: contents;">
              <span style="width: 50px;overflow: hidden;text-overflow: ellipsis;display: flow-root;">
                {{ userInfo.name != null ? userInfo.name : formatMail(userInfo.email) }}
              </span>
              <div class="el-icon-arrow-down"></div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item  @click.native="uaesLogOut()">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { delCookie } from '@/scripts/delCookie'
import { getUserInfo, ticketVerify, accountLogout } from '@/api/modules/iam'
export default {
  data() {
    return {
      userInfo: null,
      toshow: false,
      sdkConfig: {
        title: '开发套件下载',
        link: '/document/bcfe82b142f3de49ee9043adb8233b42',
        ...JSCONFIG.sdkConfig
      }
    }
  },
  created() {
    this.getTicketVerify()
  },
  methods: {
    async getTicketVerify() {
      const res = await ticketVerify()
      if (res.code === 0) {
        this.userInfo = JSON.parse(localStorage.getItem('usersCurrentInfo'))
      }
    },
    goto(page) {
      if ((this.userInfo === null && page === '/article/Beginner') || (this.userInfo === null && page === '/article/Professional') || (this.userInfo === null && page === '/document') || (this.userInfo === null && page === '/school')) {
        this.$router.push('/login')
      }
      else {
        if (page === '/document') {
          this.$router.push({ path: page + '/0' })
        }
        else {
          this.$router.push(page)
        }
      }
    },
    gotoProfessional(page) {
      if (!this.userInfo) {
        this.$router.push('/login')
      }
      else {
        if (this.userInfo.level === '0') {
          this.$confirm('是否前往人脸核身认证？', '警告', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning'
          }).then(() => {
            this.$router.push('/facialNucleus')
          }).catch(() => {
          })
        }
        else {
          this.$router.push(page)
        }
      }
    },
    async uaesLogOut() {
      const that = this
      await accountLogout()
      delCookie()
      that.$message({
        message: '退出成功！即将跳转至登录页！',
        type: 'success',
        duration: 1000
      })
      setTimeout(() => {
        that.$router.push('/login')
        localStorage.removeItem('usersCurrentInfo')
      }, 1000)
      //
      // const res = await logout()
      // if (res.code === 0) {
      //   this.$message({
      //     message: '退出成功！即将跳转至登录页！',
      //     type: 'success'
      //   })
      //   setTimeout(() => {
      //     that.$router.push('/login')
      //     localStorage.removeItem('usersCurrentInfo')
      //   }, 1000)
      // }
      // else {
      //   this.$message({
      //     message: res.msg,
      //     type: 'error'
      //   })
      // }
    },
    async togetuserInfo() {
      const res = await getUserInfo()
      console.log(res)
    },
    formatMail(mail) {
      const font = mail.slice(0, 2)
      const after = mail.slice(mail.length - 5, mail.length)
      return font + '···' + after
    }
  }
}
</script>

<style lang="less" scoped>
// 头部导航部分
.header{
  box-shadow: 1px -8px 18px 0px rgba(95,103,133,0.83);
  height: 70px;
  background: #FFFFFF;
  position: fixed;
  z-index: 1000;
  width: 100%;
  white-space : nowrap ;
  .list{
    margin:0;
    padding:0;
    display:inline-block;
    width:50%;
    li{
      cursor:pointer;
      list-style: none;
      display: inline-block;
      margin-left:5%;
      height: 70px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 70px;
    }
    li:hover{
      color: #4D78FF;
    }
    .downMenu{
      position: absolute;
      background: #fff;
      padding:0;
      margin:0;
      left: -50px;
      transition: all .2s;
      border-radius: 4px;
      overflow: hidden;
      height:0;
      li{
        display: block;
        margin:0;
        height:50px;
        line-height: 50px;
        padding: 0 20px;
        transition: all .3s;
      }
      li:hover{
        background: #5D82FF ;
        color:#fff;
      }
    }
    .el-dropdown-link:hover .downMenu{
      height:auto !important;
    }
  }
  .to_login{
    cursor:pointer;
    width: 110px;
    height: 36px;
    background: #FFFFFF;
    border: 1px solid #4D78FF;
    border-radius: 4px;
    line-height: 36px;
    text-align: center;
    color:#4D78FF;
    display: inline-block;
    position: absolute;
    top: 17px;
    right: 0px;
  }
}
.to_loginName{
    cursor:pointer;
    position: absolute;
    top: 17px;
    right: 40px;
    height: 36px;
    background: #FFFFFF;
    border-radius: 4px;
    line-height: 36px;
    text-align: center;
    color:#4D78FF;
  }
.bgColor{
  color: #5D82FF !important;
}
.tittleiImg{
  cursor:pointer;
  /**
  margin-left:75px;
  margin-right:34px;
  */
  margin-right:3px;
  margin-top:18px;
  vertical-align: top;
}
/deep/.downmenu{
  z-index: 9999999 !important;
}
.show{
  height: auto;
}
</style>
